/* The Klaviyo sign-up pop-up.

   The two Klaviyo forms (desktop STr4NV, phones UmVaYc) are built in
   Klaviyo: steps, lists, analytics and flows live there. They only open
   on a custom trigger, so this script decides when they open:
   - never while the cookie card is up or about to be, a sheet or the
     phone search screen is open, on the cart, or in the CoffeeOS app;
   - never for someone Klaviyo already knows, or who has signed up on
     this browser (pop-up or footer);
   - after a close, not again for 7 days; a small teaser stays until
     they sign up or hide it, and opens the form on click.
   While a form is open, its English is swapped for the page language
   (dropdown labels only, so the stored values stay English) and its
   photo for one that fits the visitor's "I am a" pick.
   The form's "I am a" and the site's role chip are one answer: a role
   picked on the site is filled into the form, and a role picked in the
   form changes the site's chip.
   Words and photos: snippets/os-signup.liquid. Styles: os-signup.css. */
(function () {
  "use strict";
  var D = document, W = window;
  if (W.__osSignup) return;
  W.__osSignup = 1;

  var C = {};
  try { C = JSON.parse(D.querySelector("[data-os-signup]").textContent); } catch (e) { return; }
  var T = C.t || {};

  var FORM_DESK = "STr4NV", FORM_PHONE = "UmVaYc";
  var STORE = "df_signup";
  var WEEK = 7 * 864e5;
  var DELAY = { desk: 3000, phone: 4000 };

  /* The English Klaviyo shows, matched to the words above. Keep this
     in step with the form text in Klaviyo: a line that no longer
     matches simply stays in English. */
  var SRC = {
    "Get free shipping": "headline",
    "We'll email you the code. You'll also hear first about new devices and early-bird prices, get guides from our team, and help shape what we build through user surveys.": "body",
    "Full Name": "name_label",
    "Johnny Appleseed": "name_placeholder",
    "Email": "email",
    "Send my code": "send",
    "Which one is you?": "survey_title",
    "I am a...": "survey_label",
    "Choose one": "survey_placeholder",
    /* The roles use the site chip's own words (p.<role>). */
    "Producer / mill": "p.producer",
    "Exporter": "p.exporter",
    "Importer / green buyer": "p.importer",
    "Q grader / analyst": "p.q",
    "Roaster": "p.roaster",
    "Caf\u00e9 / barista": "p.cafe",
    "Hobby brewer": "p.hobby",
    "Home roaster": "p.home",
    "Educator": "p.educator",
    "Brewing competitor": "p.competitor",
    "Continue": "continue",
    "Get it by text too": "sms_title",
    "Launch dates and early-bird prices by text. Skip it if email is enough.": "sms_body",
    "Phone Number": "phone",
    "By submitting this form, you consent to receive informational (e.g., order updates) and/or marketing texts (e.g., cart reminders) from DiFluid including texts sent by autodialer. Consent is not a condition of purchase. Msg & data rates may apply. Msg frequency varies. Unsubscribe at any time by replying STOP or clicking the unsubscribe link (where available).": "sms_disclosure",
    "Privacy Policy": "privacy",
    "Terms": "terms",
    "Text me": "sms_send",
    "No thanks": "sms_skip",
    "Check your inbox": "done_title",
    "Your free shipping code is on its way.": "done_body",
    "Open my email": "done_button",
    "This field is required": "err_required",
    "This email is invalid": "err_email",
    "This phone number is invalid": "err_phone",
    "Close dialog": "close"
  };

  /* "User type" as Klaviyo stores it (segments read these English
     values) against the site's roles. Barista is from the old form. */
  var VALUE_TO_ROLE = {
    "Coffee Farmer": "producer", "Exporter": "exporter",
    "Green Importer": "importer", "Q Grader": "q",
    "Coffee Roaster": "roaster", "Coffee Shop Owner": "cafe",
    "Barista": "cafe", "Coffee Nerd": "hobby",
    "Home Roaster": "home", "Educator": "educator",
    "Competitor": "competitor"
  };
  var ROLE_TO_VALUE = {
    producer: "Coffee Farmer", exporter: "Exporter",
    importer: "Green Importer", q: "Q Grader",
    roaster: "Coffee Roaster", cafe: "Coffee Shop Owner",
    hobby: "Coffee Nerd", home: "Home Roaster",
    educator: "Educator", competitor: "Competitor"
  };

  /* The form's options, in the order Klaviyo lists them. */
  var ROLE_ORDER = ["producer", "exporter", "importer", "q", "roaster", "cafe", "hobby", "home", "educator", "competitor"];

  var ROLE_IMG = {
    producer: "farm", exporter: "farm", importer: "farm",
    roaster: "roast", home: "roast", q: "roast",
    cafe: "brew", hobby: "brew", competitor: "brew", educator: "brew"
  };

  /* ---------- memory ---------- */
  function load() {
    try { return JSON.parse(localStorage.getItem(STORE)) || {}; } catch (e) { return {}; }
  }
  function save(o) {
    try { localStorage.setItem(STORE, JSON.stringify(o)); } catch (e) {}
  }
  function signedUp() { return load().s === "done"; }
  function markDone() { save({ s: "done", t: Date.now() }); hideTeaser(true); }
  /* "closed": the pop-up was closed. "hidden": the teaser was hidden.
     Either way the pop-up waits a week; only "closed" keeps the teaser. */
  function quietUntil() {
    var m = load();
    return (m.s === "closed" || m.s === "hidden") ? (m.t || 0) + WEEK : 0;
  }

  /* ---------- where and when ---------- */
  var isPhone = W.matchMedia("(max-width: 767px)");
  function formId() { return isPhone.matches ? FORM_PHONE : FORM_DESK; }
  function ours(id) { return id === FORM_DESK || id === FORM_PHONE; }

  function pageAllowed() {
    var html = D.documentElement;
    if (html.classList.contains("os-app")) return false;
    var p = location.pathname;
    if (/\/cart(\/|$)/.test(p)) return false;
    /* Carried over from the forms' own targeting in Klaviyo. */
    if (location.href.indexOf("pages/whats-new-at-difluid?srsltid=AfmBOoqX139YqlCJQoiTy5itcwfqLNBSb4cILZl3HIy50X743aOyiztb") !== -1) return false;
    return true;
  }

  var consentPending = true;
  (function watchConsent() {
    var S = W.Shopify;
    D.addEventListener("visitorConsentCollected", function () { consentPending = false; });
    function check(cp) {
      try {
        consentPending = cp.shouldShowBanner() && cp.currentVisitorConsent().marketing === "";
      } catch (e) { consentPending = false; }
    }
    if (S && S.customerPrivacy && S.customerPrivacy.shouldShowBanner) { check(S.customerPrivacy); return; }
    if (S && S.loadFeatures) {
      S.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (err) {
        if (!err && W.Shopify.customerPrivacy) check(W.Shopify.customerPrivacy); else consentPending = false;
      });
    } else consentPending = false;
  })();

  /* Something else has the screen right now. */
  function busy() {
    if (consentPending) return true;
    var cc = D.querySelector(".os-cc");
    if (cc && !cc.hidden) return true;
    if (D.body.classList.contains("os-locked")) return true;
    if (D.querySelector(".os-sr-on")) return true;
    var tabs = D.querySelector(".os-tabs");
    if (tabs && tabs.getAttribute("data-state") === "expanded") return true;
    return false;
  }

  var knownToKlaviyo = null, knownTries = 0;
  function checkKnown(cb) {
    if (knownToKlaviyo !== null) { cb(knownToKlaviyo); return; }
    var k = W.klaviyo;
    if (k && typeof k.isIdentified === "function") {
      try {
        Promise.resolve(k.isIdentified()).then(function (v) { knownToKlaviyo = !!v; cb(knownToKlaviyo); },
          function () { knownToKlaviyo = false; cb(false); });
        return;
      } catch (e) {}
    }
    /* No Klaviyo on the page (blocked or not loaded): nothing to open. */
    if (++knownTries < 30) setTimeout(function () { checkKnown(cb); }, 500);
  }

  var formOpen = false;
  function formEl() {
    return D.querySelector('form[data-testid="klaviyo-form-' + FORM_DESK + '"], form[data-testid="klaviyo-form-' + FORM_PHONE + '"]');
  }
  /* Klaviyo keeps a closed form in the page and fires no "open" when it
     shows it again, so look at the form itself. */
  function shown() {
    var f = formEl();
    if (!f) return false;
    var r = f.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    for (var e = f; e && e !== D.body; e = e.parentElement) {
      if (parseFloat(getComputedStyle(e).opacity) < 0.05) return false;
    }
    return true;
  }
  function openForm() {
    if (formOpen || shown()) return;
    W._klOnsite = W._klOnsite || [];
    W._klOnsite.push(["openForm", formId()]);
    setTimeout(dress, 120);
    setTimeout(dress, 600);
  }

  /* ---------- the swap ---------- */
  function norm(s) { return String(s).replace(/\u00a0/g, " ").replace(/\s+/g, " ").trim(); }
  function word(en) {
    var k = SRC[norm(en)];
    if (!k) return null;
    if (k.indexOf("p.") === 0) return (C.p && C.p[k.slice(2)]) || null;
    return T[k] || null;
  }
  var english = /^en/i.test(C.lang || "en");

  function swapText(root) {
    if (english) return;
    var w = D.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n, list = [];
    while ((n = w.nextNode())) list.push(n);
    list.forEach(function (node) {
      var raw = node.nodeValue;
      if (!raw || !raw.trim()) return;
      var to = word(raw);
      if (!to || norm(raw) === norm(to)) return;
      var lead = raw.match(/^\s*/)[0], tail = raw.match(/\s*$/)[0];
      node.nodeValue = lead + to + tail;
    });
    var els = root.querySelectorAll("[placeholder],[aria-label],[title]");
    for (var i = 0; i < els.length; i++) {
      ["placeholder", "aria-label", "title"].forEach(function (a) {
        var v = els[i].getAttribute(a);
        if (!v) return;
        var to = word(v);
        if (to && to !== v) els[i].setAttribute(a, to);
      });
    }
  }

  function pickedRole() {
    var id = "";
    try { id = (JSON.parse(localStorage.getItem("difluid_persona")) || {}).id || ""; } catch (e) {}
    return ROLE_TO_VALUE[id] ? id : "";
  }
  function photoKey() {
    return ROLE_IMG[pickedRole()] || "none";
  }
  function roleImage() {
    return (C.img && C.img[photoKey()]) || "";
  }
  function swapImage(root) {
    var src = roleImage();
    if (!src) return;
    var imgs = root.querySelectorAll("img");
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      /* Only the form's photo: never the phone field's country flag or
         anything else Klaviyo draws inside a control. */
      if (im.closest("button, .klaviyo-phoneinput, [role=listbox]")) continue;
      if (!im.hasAttribute("data-os-photo") && !/klaviyomail\.com|cloudfront\.net\/company/.test(im.getAttribute("src") || "")) continue;
      if (im.getAttribute("src") === src) continue;
      im.removeAttribute("srcset");
      im.setAttribute("src", src);
      im.setAttribute("alt", "");
      im.setAttribute("data-os-photo", photoKey());
      im.classList.add("os-kl-photo");
    }
  }

  var watcher = null;
  function dress() {
    var dlg = activeDialog();
    if (!dlg) return;
    dlg.classList.add("os-kl");
    if (watcher) watcher.disconnect();
    swapText(dlg);
    swapImage(dlg);
    fillRole(dlg);
    watcher.observe(dlg, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ["src", "placeholder", "aria-label"] });
  }
  function activeDialog() {
    var f = formEl();
    return f ? (f.closest('[role="dialog"]') || f.parentNode) : null;
  }
  if (W.MutationObserver) {
    watcher = new MutationObserver(function () {
      watcher.disconnect();
      dress();
    });
  }

  /* ---------- "I am a": form and site chip as one ---------- */
  function roleSelect(root) {
    var s = root.querySelectorAll("select");
    for (var i = 0; i < s.length; i++) {
      var o = s[i].options;
      for (var j = 0; j < o.length; j++) if (VALUE_TO_ROLE[o[j].value]) return s[i];
    }
    return null;
  }
  /* Site to form: an empty dropdown takes the role picked on the site.
     Once the visitor touches the dropdown it is theirs. */
  var touched = false;
  /* Klaviyo draws the dropdown as a typed list (Downshift): an input
     that opens a listbox of options. */
  function roleCombo(root) {
    var c = root.querySelectorAll('.klaviyo-dropdown input[role="combobox"]');
    return c.length === 1 ? c[0] : null;
  }
  var filling = false;
  function fillCombo(root, id) {
    var inp = roleCombo(root);
    if (!inp || inp.value || inp.getAttribute("data-os-filled") || filling) return;
    var n = ROLE_ORDER.indexOf(id);
    var box = inp.closest(".klaviyo-dropdown");
    var tog = box && box.querySelector('button[id$="toggle-button"]');
    if (n < 0 || !tog) return;
    inp.setAttribute("data-os-filled", "1");
    filling = true;
    tog.click();
    setTimeout(function () {
      var opts = box.querySelectorAll('[role="option"]');
      if (opts.length === ROLE_ORDER.length && opts[n]) opts[n].click();
      else if (inp.getAttribute("aria-expanded") === "true") tog.click();
      filling = false;
      if (D.activeElement === inp) inp.blur();
    }, 60);
  }
  function fillRole(root) {
    if (touched) return;
    var id = pickedRole();
    if (id && roleCombo(root)) { fillCombo(root, id); return; }
    var sel = roleSelect(root);
    if (!sel || !id || sel.value) return;
    var v = ROLE_TO_VALUE[id];
    var has = false;
    for (var i = 0; i < sel.options.length; i++) if (sel.options[i].value === v) has = true;
    if (!has) return;
    /* Klaviyo's form is React: set the value the way React reads it. */
    var set = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, "value").set;
    set.call(sel, v);
    sel.dispatchEvent(new Event("input", { bubbles: true }));
    sel.dispatchEvent(new Event("change", { bubbles: true }));
  }
  /* Form to site: picking a role in the form picks it on the site, the
     same way the chip menu does, so the page redraws for it. */
  function setSiteRole(value) {
    var id = VALUE_TO_ROLE[value];
    if (!id || id === pickedRole()) return;
    var b = D.querySelector('[data-os-roles] [data-role="' + id + '"]');
    if (b) b.click();
    else {
      var label = (C.p && C.p[id]) || id;
      try { localStorage.setItem("difluid_persona", JSON.stringify({ id: id, label: label, t: Date.now() })); } catch (e) {}
    }
    var dlg = activeDialog();
    if (dlg) swapImage(dlg);
  }
  D.addEventListener("click", function (e) {
    if (!e.isTrusted || filling) return;
    var o = e.target.closest && e.target.closest('.klaviyo-dropdown [role="option"]');
    var dlg = activeDialog();
    if (!o || !dlg || !dlg.contains(o)) return;
    var opts = o.parentNode.querySelectorAll('[role="option"]');
    var n = Array.prototype.indexOf.call(opts, o);
    if (opts.length !== ROLE_ORDER.length || n < 0) return;
    touched = true;
    setSiteRole(ROLE_TO_VALUE[ROLE_ORDER[n]]);
  }, true);
  D.addEventListener("change", function (e) {
    var t = e.target;
    if (!e.isTrusted || !t || t.tagName !== "SELECT") return;
    var dlg = activeDialog();
    if (!dlg || !dlg.contains(t) || t !== roleSelect(dlg)) return;
    touched = true;
    setSiteRole(t.value);
  }, true);

  /* ---------- teaser ---------- */
  var teaser = null;
  function buildTeaser() {
    if (teaser) return teaser;
    teaser = D.createElement("div");
    teaser.className = "os-st";
    teaser.hidden = true;
    teaser.innerHTML =
      '<button type="button" class="os-st__go" data-st="go"><span class="os-st__dot" aria-hidden="true"></span><span class="os-st__txt"></span></button>' +
      '<button type="button" class="os-st__x" data-st="hide"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M7 7l10 10M17 7 7 17"/></svg></button>';
    teaser.querySelector(".os-st__txt").textContent = T.teaser || "";
    var x = teaser.querySelector(".os-st__x");
    x.setAttribute("aria-label", T.teaser_hide || "");
    x.setAttribute("title", T.teaser_hide || "");
    teaser.addEventListener("click", function (e) {
      var b = e.target.closest("[data-st]");
      if (!b) return;
      if (b.getAttribute("data-st") === "go") { hideTeaser(false); openForm(); }
      else { save({ s: "hidden", t: Date.now() }); hideTeaser(true); }
    });
    D.body.appendChild(teaser);
    return teaser;
  }
  var teaserWanted = false;
  function showTeaser() { teaserWanted = true; place(); }
  function hideTeaser(forGood) {
    if (forGood) teaserWanted = false;
    if (teaser) { teaser.classList.remove("is-on"); teaser.hidden = true; }
  }

  /* Desktop: bottom left, clear of the side menu (the cookie card is
     bottom right). Phones: just above the tab bar, at the end. */
  function place() {
    if (!teaserWanted || formOpen || shown() || busy() || !pageAllowed()) { hideTeaser(false); return; }
    buildTeaser();
    var html = D.documentElement;
    var rtl = (html.getAttribute("dir") || "").toLowerCase() === "rtl";
    var start = 16, bottom = 16;
    if (isPhone.matches) {
      var tabs = D.querySelector(".os-tabs");
      if (tabs && getComputedStyle(tabs).display !== "none") {
        var r = tabs.getBoundingClientRect();
        bottom = Math.max(16, Math.round(W.innerHeight - r.top + 10));
      }
      teaser.style.setProperty("--st-start", "auto");
      teaser.style.setProperty("--st-end", "12px");
    } else {
      var side = D.querySelector(".os-sidebar");
      if (side && getComputedStyle(side).display !== "none") {
        var s = side.getBoundingClientRect();
        if (s.width > 0) start = Math.round(rtl ? W.innerWidth - s.left : s.right) + 24;
      } else start = 24;
      bottom = 24;
      teaser.style.setProperty("--st-start", start + "px");
      teaser.style.setProperty("--st-end", "auto");
    }
    teaser.style.setProperty("--st-bottom", bottom + "px");
    if (teaser.hidden) {
      teaser.hidden = false;
      void teaser.offsetWidth;
    }
    teaser.classList.add("is-on");
  }

  /* ---------- sign-up event ----------
     newsletter_signup goes to GA4, Shopify customer events and the
     dataLayer through osTrack. Klaviyo records the subscription itself,
     so it is not sent there. Once a page view: the pop-up fires
     stepSubmit for every step. */
  var signupSent = false;
  function trackSignup(where, formId, md) {
    if (signupSent) return;
    signupSent = true;
    try { if (W.osTrack) W.osTrack("newsletter_signup", { form: where, form_id: formId || "" }); } catch (e) {}
    /* Meta's Lead. The footer form already sends it from the lead
       watcher in layout/theme.liquid (it watches kmail-lists.com);
       the pop-up posts to Klaviyo's own API, which that watcher does
       not see, so the pop-up sends df_lead here. The "DiFluid Landing
       Events" custom pixel turns df_lead into Lead. */
    if (where !== "popup") return;
    md = md || {};
    var email = md.$email || md.email || md.Email || "";
    try {
      if (W.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish("df_lead", {
          email: email, name: "", phone: md.$phone_number || "",
          page: location.pathname, form_source: "klaviyo-popup", url: location.href
        });
      }
    } catch (e) {}
  }

  /* ---------- Klaviyo's events ---------- */
  W.addEventListener("klaviyoForms", function (e) {
    var d = e.detail || {};
    if (!ours(d.formId)) return;
    if (d.type === "open") {
      formOpen = true;
      hideTeaser(false);
      dress();
      setTimeout(dress, 60);
    } else if (d.type === "submit" || d.type === "stepSubmit") {
      var md = d.metaData || {};
      trackSignup("popup", d.formId, md);
      if (md["User type"]) setSiteRole(md["User type"]);
      markDone();
      dress();
    } else if (d.type === "close") {
      formOpen = false;
      if (watcher) watcher.disconnect();
      if (!signedUp()) { save({ s: "closed", t: Date.now() }); showTeaser(); }
    }
  });

  /* The footer sign-up counts too. */
  (function watchFooter() {
    var msg = D.querySelector("[data-os-news-msg]");
    if (!msg || !W.MutationObserver) return;
    new MutationObserver(function () {
      if (msg.classList.contains("is-ok") && !msg.hidden) { markDone(); trackSignup("footer", ""); }
    }).observe(msg, { attributes: true, attributeFilter: ["class", "hidden"] });
  })();

  /* ---------- go ---------- */
  function start() {
    if (signedUp() || !pageAllowed()) return;
    checkKnown(function (known) {
      if (known) return;
      var m = load();
      if (m.s === "closed" && Date.now() < quietUntil()) { showTeaser(); return; }
      if (m.s === "hidden" && Date.now() < quietUntil()) return;
      var wait = isPhone.matches ? DELAY.phone : DELAY.desk;
      var t0 = Date.now();
      (function tick() {
        if (formOpen || shown() || signedUp()) return;
        if (Date.now() - t0 < wait || busy()) { setTimeout(tick, 500); return; }
        openForm();
      })();
    });
  }

  var raf = 0;
  function replace() {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; if (teaserWanted) place(); });
  }
  W.addEventListener("resize", replace);
  W.addEventListener("scroll", replace, { passive: true });
  setInterval(function () { if (teaserWanted) place(); }, 1000);

  if (D.readyState === "loading") D.addEventListener("DOMContentLoaded", start);
  else start();
})();
